import type { TimelineStep } from "./model";

/**
 * Was Creator sehen (Befund 20): Einstellung je Agentur (org_settings.creator_visibility, lesbar über org_profiles, 0058).
 *   share  – nur der eigene Anteil (kein Markenbudget, keine Provision in Euro, kein Zahlungsstand der Marke)
 *   budget – dazu Markenbudget und Provision in Euro
 *   full   – dazu der Zahlungsstand der Marke (Standard, wie bisher)
 * Die Anzeige richtet sich danach; die Beträge selbst rechnet das Portal wie immer.
 */
export type CreatorVisibility = "share" | "budget" | "full";

export const VISIBILITIES: readonly CreatorVisibility[] = ["share", "budget", "full"];

export function visibilityOf(org: unknown): CreatorVisibility {
  const v = org && typeof org === "object" ? (org as { creator_visibility?: unknown }).creator_visibility : null;
  return v === "share" || v === "budget" || v === "full" ? v : "full";
}

/** Markenbudget (Honorar vor Provision) und Provision in Euro */
export const showsBudget = (v: CreatorVisibility): boolean => v !== "share";
/** Ob die Marke schon an die Agentur gezahlt hat */
export const showsBrandPayment = (v: CreatorVisibility): boolean => v === "full";

const BRAND_PAYMENT_LABELS = new Set(["Zahlung der Marke", "Payment by the brand"]);

/** Schritt „Zahlung der Marke“ der Rechnungs-Zeitleiste (Abrechnung über die Agentur); bei direkter Abrechnung zahlt die Marke an dich und bleibt sichtbar. */
export function isBrandPaymentStep(step: Pick<TimelineStep, "label">): boolean {
  return BRAND_PAYMENT_LABELS.has(step.label);
}

export function visibleTimeline<T extends Pick<TimelineStep, "label">>(steps: readonly T[], v: CreatorVisibility): T[] {
  return showsBrandPayment(v) ? [...steps] : steps.filter((s) => !isBrandPaymentStep(s));
}
